// extracted by mini-css-extract-plugin
module.exports = {"root":"ProcedureTabs_root__2qO1Y","tab":"ProcedureTabs_tab__2Vn1T"};